const SourcePointTrigger = ({ messageId = 1192723}) => {
    const handleClick = e => {
        e.preventDefault();
        if (window._sp_?.usnat) {
            window._sp_.usnat.loadPrivacyManagerModal(messageId);
        } else {
            console.warn('Sourcepoint usnat not found.')
        }
    }
    
    return (
        <li className="footer-nav__item">
            {/*eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a 
                href="#" 
                className="footer-nav__link" 
                target="_self"
                role="button"
                onClick={handleClick}
            >
                Do Not Sell My Info
            </a>
        </li>
    )
}

export default SourcePointTrigger